import Vue from 'vue'
import Vuex from 'vuex'

// modules
import auth from './auth'
import user from './user'
import project from './project'
import settings from './settings'
import navigation from './navigation'
// import lang from './lang'
// import services from './services'
import dsahboard from './dsahboard'
import metadata from './metadata'
import keyword from './keyword'
import pagination from './pagination'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    user,
    project,
    settings,
    navigation,
    metadata,
    keyword,
    pagination,
    dsahboard
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js